// extracted by mini-css-extract-plugin
export default {"image-preview":"UpdateProduct_image-preview__YDylh","delete-image":"UpdateProduct_delete-image__XQL49","image-preview1":"UpdateProduct_image-preview1__hDLQa"};